import { ISize } from '@shared/definitions';
import { getImgSize } from './getImgSize';

export const isImgSizeCorrect = (file: File, maxImgRes, callback) => {
  getImgSize(URL.createObjectURL(file)).subscribe((size: ISize) => {
    callback(size.width <= maxImgRes ? size.height <= maxImgRes : false);
  });
};
